/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import {
	LatestNewsSectionFragment,
	CosmosEnumLatestNewsVariants,
	CosmosEnumBlogCardsMaxSize,
} from "@cosmos/hygraph-schema";
import {
	BlogCardProps,
	BlogCardsSection,
	FeedCardOrganism,
	FeedItem,
	NewsCardProps,
	NewsCardsSection,
} from "@components/elements";
import { useCosmosComponentContext } from "@components/context";
import { useLocale } from "@epic-mw/i18n";
import { FeaturedBlogCardsSection } from "./FeaturedBlogCards.section";

interface ExternalLatestNewsData {
	cards?: BlogCardProps[] | NewsCardProps[] | FeedItem[] | null;
}

export type LatestNewsSectionAndExternalProps = LatestNewsSectionFragment &
	ExternalLatestNewsData & {
		feedBrand?: string | null;
		disableCategoryPills?: boolean | null;
	};

export const LatestNewsSection = ({
	config,
	cards = [],
	feedBrand,
	featuredLabel,
	latestNewsVariant,
	disableCategoryPills,
}: LatestNewsSectionAndExternalProps): React.JSX.Element | null => {
	const locale = useLocale();
	const { feedBrand: contextFeedBrand, locales } = useCosmosComponentContext();
	const currentBrand = feedBrand ?? contextFeedBrand;
	const hideCategoryPills = Boolean(disableCategoryPills);

	if (!cards?.length) return null;
	switch (latestNewsVariant) {
		case CosmosEnumLatestNewsVariants.Large5: {
			return (
				<FeaturedBlogCardsSection
					__typename="CosmosSectionBlogCard"
					id=""
					config={config}
					cards={cards.slice(0, 5) as BlogCardProps[]}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.MediumFlipFeatured10: {
			return (
				<FeedCardOrganism
					locale={locale}
					locales={locales}
					items={cards.slice(0, 10) as FeedItem[]}
					featuredLabel={featuredLabel}
					enableAnimate={false}
					flipFeatured={true}
					currentBrand={currentBrand}
					hideCategoryPills={hideCategoryPills}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.Medium3: {
			return (
				<BlogCardsSection
					config={config}
					cards={cards.slice(0, 3) as BlogCardProps[]}
					maxSize={CosmosEnumBlogCardsMaxSize.Three}
					hideCategoryPills={hideCategoryPills}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.Small4: {
			return (
				<NewsCardsSection
					config={config}
					cards={cards.slice(0, 4) as NewsCardProps[]}
					maxCards={4}
					hideCategoryPills={hideCategoryPills}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.Medium4Up: {
			return (
				<BlogCardsSection
					config={config}
					cards={cards.slice(0, 4) as BlogCardProps[]}
					maxSize={CosmosEnumBlogCardsMaxSize.Four}
					hideCategoryPills={hideCategoryPills}
				/>
			);
		}
		default: {
			return (
				<NewsCardsSection
					config={config}
					cards={cards.slice(0, 2) as NewsCardProps[]}
					maxCards={2}
					hideCategoryPills={hideCategoryPills}
				/>
			);
		}
	}
};
